import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { isValidHttpsUrl } from 'theSource/utils';
import { NavProps } from '../../types';
import { NavButtonStyled, NavTextStyled, IconStyled } from '../../TopNavStyled';

export const NavItem = (navItem: NavProps) => {
  const { t } = useTranslation('pages.home');
  const navigate = useNavigate();

  const handleClick = () =>
    isValidHttpsUrl(navItem.path!)
      ? window.open(navItem.path!, '_blank')
      : navigate(navItem.path!);

  const isMobileView = window.innerWidth < 744;

  if (isMobileView && navItem.lookupCode === 'my_benefits') {
    return null;
  }

  return (
    <NavButtonStyled
      id={navItem.lookupCode}
      className='custom-header-button'
      onClick={handleClick}
      data-testid='top-nav-button'
    >
      <IconStyled>
        <navItem.phosphorIcon size={32} aria-hidden="true" role="presentation" className='img-fluid'/>
      </IconStyled>
      <div>
        <NavTextStyled>{t(navItem.label)}</NavTextStyled>
      </div>
    </NavButtonStyled>
  );
};
